import Vue from "vue";
import Vuex from "vuex";
import menu from "./modules/menu.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    menu,
  },
});
